/**
 * Core MuiDateTimePicker Component
 *
 * A wrapper around `@mui/x-date-pickers/DateTimePicker` that automatically
 * includes the required LocalizationProvider and AdapterDayjs.
 *
 * @example
 *   <MuiDateTimePicker label="Start Time" value={val} onChange={setVal} />
 */
import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';
import { Dayjs } from 'dayjs';

// We explicitly type the props to expect Dayjs
export interface MuiDateTimePickerProps extends Partial<DateTimePickerProps> {}

export function MuiDateTimePicker(props: MuiDateTimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker {...props} />
    </LocalizationProvider>
  );
}

export default MuiDateTimePicker;
